import { useEffect, useRef } from 'react';

/**
 * Rebusca quando `open` vira true.
 *
 * Serve pros cadastros do tenant (etiquetas, mensagens rápidas, motivos de
 * fechamento), que NÃO vencem por tempo: em vez de um prazo — curto demais
 * gasta à toa, longo demais mostra dado velho — a busca acontece no momento
 * em que o atendente abre a lista.
 *
 * Só dispara na TRANSIÇÃO false→true. Sem isso, um `open` que continua true
 * entre renders (ex.: o dropdown do `/` no Composer, cujo efeito roda a cada
 * tecla) buscaria a cada letra digitada.
 *
 * Para componentes que só existem enquanto abertos (montados de forma
 * condicional), passe `true` — nascer JÁ É o abrir, e o ref começa em false.
 */
export function useRefetchOnOpen(open: boolean, refetch: () => void): void {
  const wasOpenRef = useRef(false);
  useEffect(() => {
    if (open && !wasOpenRef.current) refetch();
    wasOpenRef.current = open;
  }, [open, refetch]);
}
